/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { useState, useRef } from 'react';
import { IMoeAddtocollectionViewProps } from './moe-addtocollection';
import { INodeProps, Modal, Node } from '@msdyn365-commerce-modules/utilities';
import { AiOutlinePlus } from 'react-icons/ai';
import { FaPlus } from 'react-icons/fa';
import { CollectionItem } from '../../components/collectionitem.component';
// import { getByIdsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
// import { searchByCategoryAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
// import { createReadAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductListsDataActions.g';
import {
    getByCustomerAsync,
    createCommerceListAsync,
    addLinesAsync,
    createGetByCustomerInput,
    updateAsync,
    deleteAsync
    // createInvitationsAsync,
    // acceptInvitationAsync
} from '@msdyn365-commerce/retail-proxy/dist/DataActions/CommerceListsDataActions.g';
import { SimpleProduct, CartLine, ProductDimension, CommerceList, AsyncResult } from '@msdyn365-commerce/retail-proxy';
import MsDyn365, { IComponentProps } from '@msdyn365-commerce/core';
import { buildWishlistLine } from '@msdyn365-commerce-modules/retail-actions';
import * as Popper from 'popper.js';
import { IMoeAddtocollectionData } from './moe-addtocollection.data';
import { getToggleLang, getUserPreferredLanguage, getUserPrefLang } from '../../utilities/language-change';
import { MAORI_LANG, ERROR_OR_NOTIFICATION, COLLECTIONS, ACTION_BUTTONS, COLLECTIONS_SITE_LANGUAGE } from '../../utilities/constants';
//import MsDyn365 from '@msdyn365-commerce/core';

// import { validateCustomerDetailsAsync } from '../../actions/extensions/DataActionExtension.g';
// import { getElementsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/RecommendationsDataActions.g';
// import { CommerceList } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

export interface IAddToWishlistComponentProps extends IComponentProps<IMoeAddtocollectionData> {
    className?: string;
    addToWishlistButtonText: string;
    removeFromWishlistButtonText: string;
    nameOfWishlist: string;

    addToWishlistMessage?: string;
    removedFromWishlistMessage?: string;
    addItemToWishlistError?: string;
    removeItemFromWishlistError?: string;

    showButtonText?: boolean;
    showButtonTooltip?: boolean;
    tooltipPosition?: Popper.Placement;
    showStatusMessage?: boolean;
    showRemoveButton?: boolean;
    disabled?: boolean;
    cartline?: CartLine;
    canAddMasterProduct?: boolean;
    ariaRole?: string;

    getSelectedProduct?: Promise<SimpleProduct | null>;

    onSuccess?(result: IWishlistActionSuccessResult, cartline?: CartLine): void;
    onError?(result: IWishlistActionErrorResult): void;
}

export interface IWishlistActionSuccessResult {
    status: 'ADDED' | 'REMOVED';
}

export interface IWishlistActionErrorResult {
    status: 'FAILED' | 'MISSINGDIMENSION';

    missingDimensions?: ProductDimension[];
}

export default (props: IMoeAddtocollectionViewProps) => {
    console.log('***Add to collection***', props);

    // variable defintions
    const collectionMockData: any = [];
    const user = props.context.request.user;
    const { context, resources } = props;
    //@ts-ignore
    const { product } = props.data;
    const toggleLang = getToggleLang(context);
    const userPrefLang = getUserPrefLang(user.customerAccountNumber, context);
    const CollectionLang = getUserPreferredLanguage(props.config?.siteName as any, COLLECTIONS, userPrefLang, toggleLang, context);
    const ActionButtonLang = getUserPreferredLanguage(props.config?.siteName as any, ACTION_BUTTONS, userPrefLang, toggleLang, context);
    const errorOrNotificationMsgLang = getUserPreferredLanguage(
        props.config.siteName as any,
        ERROR_OR_NOTIFICATION,
        userPrefLang,
        toggleLang,
        context
    );
    // Need to check
    const collectionSiteLang = getUserPreferredLanguage(
        props.config.siteName as any,
        COLLECTIONS_SITE_LANGUAGE,
        userPrefLang,
        toggleLang,
        context
    );

    const appendLangWordProf = CollectionLang === MAORI_LANG ? 'InMaori' : '';
    const appendLangWordActBtn = ActionButtonLang === MAORI_LANG ? 'InMaori' : '';
    const appendLangWordError = errorOrNotificationMsgLang === MAORI_LANG ? 'InMaori' : '';

    // const [appendLangWord, setAppendLang] = useState('');
    // const MoeErrorMessages = {
    //     unknownError: props.resources[`unknownError${appendLangWord}`],
    //     emptyCollection: props.resources[`emptyCollection${appendLangWord}`],
    //     emptyCollections: props.resources[`emptyCollections${appendLangWord}`],
    //     duplicateName: props.resources[`duplicateName${appendLangWord}`],
    //     duplicateResource: props.resources[`duplicateResource${appendLangWord}`],
    //     unAuthenticated: props.resources[`unAuthenticated${appendLangWord}`],
    //     noAccountNumber: props.resources[`noAccountNumber${appendLangWord}`],
    //     networkOffline: props.resources[`networkOffline${appendLangWord}`],
    //     exceededCollectionNameLimit: props.resources[`exceededCollectionNameLimit${appendLangWord}`],
    //     noEmptyCollectionSharing: props.resources[`noEmptyCollectionSharing${appendLangWord}`]
    // };
    // const MoeSuccessMessages = {
    //     createCOllection: props.resources[`createCOllection${appendLangWord}`],
    //     addResource: props.resources[`addResource${appendLangWord}`],
    //     updateCollection: props.resources[`updateCollection${appendLangWord}`],
    //     updateCollectionName: props.resources[`updateCollectionName${appendLangWord}`],
    //     deleteCollection: props.resources[`deleteCollection${appendLangWord}`],
    //     deleteProduct: props.resources[`deleteProduct${appendLangWord}`]
    // };

    const MoeErrorMessages = {
        unknownError: props.resources[`unknownError`],
        emptyCollection: props.resources[`emptyCollection`],
        emptyCollections: props.resources[`emptyCollections`],
        duplicateName: props.resources[`duplicateName`],
        duplicateResource: props.resources[`duplicateResource`],
        unAuthenticated: props.resources[`unAuthenticated`],
        noAccountNumber: props.resources[`noAccountNumber`],
        networkOffline: props.resources[`networkOffline`],
        exceededCollectionNameLimit: props.resources[`exceededCollectionNameLimit`],
        noEmptyCollectionSharing: props.resources[`noEmptyCollectionSharing`],
        unknownErrorInMaori: props.resources[`unknownErrorInMaori`],
        emptyCollectionInMaori: props.resources[`emptyCollectionInMaori`],
        emptyCollectionsInMaori: props.resources[`emptyCollectionsInMaori`],
        duplicateNameInMaori: props.resources[`duplicateNameInMaori`],
        duplicateResourceInMaori: props.resources[`duplicateResourceInMaori`],
        unAuthenticatedInMaori: props.resources[`unAuthenticatedInMaori`],
        noAccountNumberInMaori: props.resources[`noAccountNumberInMaori`],
        networkOfflineInMaori: props.resources[`networkOfflineInMaori`],
        exceededCollectionNameLimitInMaori: props.resources[`exceededCollectionNameLimitInMaori`],
        noEmptyCollectionSharingInMaori: props.resources[`noEmptyCollectionSharingInMaori`]
    };
    const MoeSuccessMessages = {
        createCOllection: props.resources[`createCOllection`],
        addResource: props.resources[`addResource`],
        updateCollection: props.resources[`updateCollection`],
        updateCollectionName: props.resources[`updateCollectionName`],
        deleteCollection: props.resources[`deleteCollection`],
        deleteProduct: props.resources[`deleteProduct`],
        createCOllectionInMaori: props.resources[`createCOllectionInMaori`],
        addResourceInMaori: props.resources[`addResourceInMaori`],
        updateCollectionInMaori: props.resources[`updateCollectionInMaori`],
        updateCollectionNameInMaori: props.resources[`updateCollectionNameInMaori`],
        deleteCollectionInMaori: props.resources[`deleteCollectionInMaori`],
        deleteProductInMaori: props.resources[`deleteProductInMaori`]
    };

    const MoeModuleTranslations = {
        notLoggedIn: props.resources[`notLoggedIn${appendLangWordError}`],
        addToCollectionText: props.resources[`addToCollectionText${appendLangWordActBtn}`],
        heyText: props.resources[`heyText${appendLangWordError}`],
        addNewCollection: props.resources[`addNewCollection${appendLangWordError}`],
        newCollectionText: props.resources[`newCollectionText${appendLangWordProf}`]
        //selectResourcesHoverText: props.resources[`addToCollectionText${appendLangWordError}`]
    };

    // State definitions
    const [collectionArray, setCollectionArray] = useState<any[]>(collectionMockData);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCollection, setSelectedCollection] = useState<any>({ index: -1, collectionId: -1 });
    const [isCollectionEditable, setIsCollectionEditable] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [isCollectionCreated, setIsCollectionCreated] = useState(false);
    const [errorMessage, setErrorMessage] = useState<any>('');
    const [isAlertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState<any>('');
    const [isRefreshPage, setIsRefreshPage] = useState(false);

    // Ref definitions
    const scrollRef: any = useRef();
    const [hasBeenCalled, setHasBeenCalled] = useState(false);
    console.log('User details', user);

    async function getCollectionList() {
        if (user?.isAuthenticated) {
            try {
                const { context } = props;
                const collectionList = await getByCustomerAsync({ callerContext: context.actionContext, bypassCache: 'get' }, null);
                setCollectionArray([...collectionList]);
                console.log('Get all the customers data', collectionList);
            } catch (err) {
                const errorLang = getErrorOrSuccessMessage();
                setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.unknownErrorInMaori : MoeErrorMessages.unknownError);
                console.error(err);
            }
        }
    }

    const getErrorOrSuccessMessage = () => {
        const toggleLang = getToggleLang(context);
        const userPrefLang = getUserPrefLang(user.customerAccountNumber, context);
        const errorOrNotificationMsgLang = getUserPreferredLanguage(
            props.config.siteName as any,
            ERROR_OR_NOTIFICATION,
            userPrefLang,
            toggleLang,
            context
        );
        return errorOrNotificationMsgLang;
    };

    const openModal = async (e: any): Promise<void> => {
        console.log('testing', e, typeof e);
        e.preventDefault();
        setIsModalOpen(true);
        setIsCollectionCreated(false);
        void getCollectionList();
        if (!props.context.request.User.IsAuthenticated) {
            return;
        }
    };

    const closeModal = async (): Promise<void> => {
        setSelectedCollection({ index: -1, collectionId: -1 });
        setIsModalOpen(false);
    };

    const _modalContainer = (): INodeProps => {
        return {
            tag: Modal,
            placement: 'bottom-end',
            hideArrow: true,
            className: `ms-add-collection-container ${isModalOpen ? 'fadeInRight' : 'fadeOutRight'}`,
            wrapClassName: 'ms-add-collection__modal',
            isOpen: isModalOpen,
            toggle: closeModal
        };
    };

    const selectCollection = (index: number, collectionId: number): void => {
        setErrorMessage('');
        if (selectedCollection?.collectionId === collectionId) {
            setSelectedCollection({ index: -1, collectionId: -1 });
        } else {
            setSelectedCollection({ index, collectionId });
            console.log(selectedCollection);
        }
    };

    const toggleEditableCollection = (index: any) => {
        // setErrorMessage('');
        // collectionNameRef.current.value = collectionName ? collectionName : '';
        setCurrentIndex(index);
        console.log(index, currentIndex, isCollectionEditable);
        setIsCollectionEditable(!isCollectionEditable);
    };

    // @info: This method is used create unique id
    const makeid = (length: number) => {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    };

    // @info: This method checks the internet connection
    const isInternetConnectionAvailable = () => {
        if (MsDyn365.isBrowser && window?.navigator?.onLine === false) {
            const errorLang = getErrorOrSuccessMessage();
            setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.networkOfflineInMaori : MoeErrorMessages.networkOffline);
            return false;
        } else if (MsDyn365.isBrowser && window?.navigator?.onLine === true) {
            return true;
        }
        return;
    };

    // @info: This method is used to check whether the collection exists
    const doesCollectionExist = async (collectionId: number): Promise<any> => {
        const { context } = props;
        const collectionArray = await getByCustomerAsync({ callerContext: context.actionContext, bypassCache: 'get' }, null);
        if (!collectionArray || !collectionArray[0]) {
            return false;
        }
        console.log(collectionArray);

        const collection = collectionArray.find(collectionItem => collectionItem.Id === collectionId);

        console.log(collection);

        if (!collection) {
            return false;
        } else {
            return true;
        }
    };

    // @info: This method is used to check whether product exists in the given collection
    const doesProductExistInCollection = async (productId: number, collectionId: number): Promise<any> => {
        const { context } = props;
        try {
            const collectionArray = await getByCustomerAsync({ callerContext: context.actionContext, bypassCache: 'get' }, null);

            if (!collectionArray || !(collectionArray.length > 0)) {
                return false;
            }

            const collection = collectionArray.find(collectionItem => collectionItem.Id === collectionId);
            if (!collection) {
                return false;
            }

            const CommerceListLines: any = collection.CommerceListLines;
            for (const collectionProductItem of CommerceListLines) {
                if (collectionProductItem.ProductId === productId) {
                    return true;
                }
            }

            return false;
        } catch (e) {
            const errorLang = getErrorOrSuccessMessage();
            setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.unknownErrorInMaori : MoeErrorMessages.unknownError);
        }
    };

    // @info: This method checks whether given name already exists in the existing collections
    const doesDuplicateNameExists = async (collectionName: string): Promise<any> => {
        const { context } = props;
        const collectionList = await getByCustomerAsync({ callerContext: context.actionContext, bypassCache: 'get' }, null);
        // setCollectionArray(collectionList);
        if (collectionList) {
            const filteredItem = collectionList.find(collection => collection?.Name === collectionName);
            if (filteredItem) {
                return true;
            } else {
                return false;
            }
        } else {
            const errorLang = getErrorOrSuccessMessage();
            setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.emptyCollectionsInMaori : MoeErrorMessages.emptyCollections);
            return {
                errorCode: 404,
                errorMessage: errorLang === MAORI_LANG ? MoeErrorMessages.emptyCollectionsInMaori : MoeErrorMessages.emptyCollections
            };
        }
    };

    // @info: This method is used specifically to create a collection
    const createCollection = async (): Promise<any> => {
        setErrorMessage('');
        const { context } = props;
        const isNetworkAvailable = isInternetConnectionAvailable();
        if (isNetworkAvailable === false) {
            return;
        }

        if (user.isAuthenticated) {
            if (user && user.customerAccountNumber) {
                const listData: CommerceList = {
                    CustomerId: user.customerAccountNumber,
                    Name: `New collection ${makeid(5)}`,
                    CommerceListTypeValue: 1,
                    Id: 0
                };
                const isDuplicateName = await doesDuplicateNameExists(listData?.Name as string);
                console.log(isDuplicateName);
                if (!isDuplicateName) {
                    try {
                        console.log(listData);
                        const commerceList = await createCommerceListAsync({ callerContext: context.actionContext }, listData);
                        setIsCollectionCreated(true);
                        setCollectionArray([
                            {
                                Id: commerceList.Id,
                                Name: listData.Name,
                                CustomerId: commerceList.CustomerId,
                                CommerceListTypeValue: 1,
                                collectionType: 'New',
                                CommerceListLines: commerceList.CommerceListLines,
                                IsPrivate: commerceList.IsPrivate
                            },
                            ...collectionArray
                        ]);
                    } catch (error) {
                        const errorLang = getErrorOrSuccessMessage();
                        setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.unknownErrorInMaori : MoeErrorMessages.unknownError);
                        if (context.telemetry) {
                            context.telemetry.warning(error);
                            context.telemetry.debug('[AddCollection] Unable to create a collection');
                        }
                    }
                } else {
                    const errorLang = getErrorOrSuccessMessage();
                    setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.duplicateNameInMaori : MoeErrorMessages.duplicateName);
                    return Promise.reject({
                        errorCode: 400,
                        errorMessage: 'Same name already exists in collection'
                    });
                }
            } else {
                const errorLang = getErrorOrSuccessMessage();
                setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.noAccountNumberInMaori : MoeErrorMessages.noAccountNumber);
                context.telemetry.debug('[AddCollection] Customer account number missing');
            }
        } else {
            const errorLang = getErrorOrSuccessMessage();
            setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.unAuthenticatedInMaori : MoeErrorMessages.unAuthenticated);
        }
    };

    // @info: This method is used to create new collection and add product into collection
    const addToCollection = async (collectionId: number): Promise<void> => {
        if (!hasBeenCalled) {
            setHasBeenCalled(true);
            setErrorMessage('');
            const isNetworkAvailable = isInternetConnectionAvailable();
            if (isNetworkAvailable === false) {
                return;
            }

            const { context } = props;
            if (user.isAuthenticated) {
                console.log(collectionId);
                const isCollectionAvailable = await doesCollectionExist(collectionId);
                console.log(isCollectionAvailable);
                if (!isCollectionAvailable) {
                    const collection = collectionArray.find(collectionItem => collectionItem.Id === collectionId);
                    const collectionName = collection?.Name;
                    if (user && user.customerAccountNumber) {
                        const listData: CommerceList = {
                            CustomerId: user.customerAccountNumber,
                            Name: collectionName,
                            CommerceListTypeValue: 1,
                            Id: 0
                        };

                        try {
                            console.log(listData);
                            const commerceList = await createCommerceListAsync({ callerContext: context.actionContext }, listData);
                            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
                            return addCollectionLine(commerceList.Id, (await product)?.RecordId as any);
                        } catch (error) {
                            const errorLang = getErrorOrSuccessMessage();
                            setErrorMessage(
                                errorLang === MAORI_LANG ? MoeErrorMessages.unknownErrorInMaori : MoeErrorMessages.unknownError
                            );
                            if (context.telemetry) {
                                context.telemetry.warning(error);
                                context.telemetry.debug('[AddCollection] Unable to create a wishlist');
                            }
                            // propagateError(props, { status: 'FAILED' });
                        }
                    } else {
                        const errorLang = getErrorOrSuccessMessage();
                        setErrorMessage(
                            errorLang === MAORI_LANG ? MoeErrorMessages.noAccountNumberInMaori : MoeErrorMessages.noAccountNumber
                        );
                        context.telemetry.debug('[AddCollection] Customer account number missing');
                    }
                } else {
                    return addCollectionLine(collectionId, (await product)?.RecordId);
                }
            } else {
                const errorLang = getErrorOrSuccessMessage();
                setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.unAuthenticatedInMaori : MoeErrorMessages.unAuthenticated);
                return;
            }
            setHasBeenCalled(false);
            return AsyncResult.resolve();
        }
    };

    // @info: This method is used to add product to the collection
    const addCollectionLine = async (collectionId: number, productId: number): Promise<void> => {
        const { context } = props;

        try {
            if (user && user.customerAccountNumber) {
                const isCollectionLineAvailable = await doesProductExistInCollection(productId, collectionId);
                if (!isCollectionLineAvailable) {
                    const createdCommerceList = await addLinesAsync({ callerContext: context.actionContext }, collectionId, [
                        buildWishlistLine(productId, user.customerAccountNumber, collectionId)
                    ]);
                    console.log(createdCommerceList);
                    context.actionContext.update(createGetByCustomerInput({}, null), [createdCommerceList]);
                    if (context.telemetry) {
                        context.telemetry.debug(`[AddCollectionLine] Added item to the wishlist ${createdCommerceList}`);
                    }
                } else {
                    const errorLang = getErrorOrSuccessMessage();
                    setErrorMessage(
                        errorLang === MAORI_LANG ? MoeErrorMessages.duplicateResourceInMaori : MoeErrorMessages.duplicateResource
                    );
                    return;
                }
            } else {
                const errorLang = getErrorOrSuccessMessage();
                setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.noAccountNumberInMaori : MoeErrorMessages.noAccountNumber);
                context.telemetry.debug('[AddCollectionLine] Customer Account number missing');
            }
        } catch (error) {
            const errorLang = getErrorOrSuccessMessage();
            setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.unknownErrorInMaori : MoeErrorMessages.unknownError);
            if (context.telemetry) {
                context.telemetry.warning(error);
                context.telemetry.debug(`[AddCollectionLine] Unable to add item to wishlist ${error}`);
            }
            // propagateError(props, { status: 'FAILED' });
        }

        setIsModalOpen(false);
        const successLang = getErrorOrSuccessMessage();
        openAlert(successLang === MAORI_LANG ? MoeSuccessMessages.addResourceInMaori : MoeSuccessMessages.addResource, true);
        //location.reload();
        return AsyncResult.resolve();
    };

    // @info: This method updates the collection name using collection id and new name
    const updateCollectionName = async (collectionId: number, changedCollectionName: string, setCollectionTitle: any) => {
        const { telemetry } = props.context;
        setErrorMessage('');
        const isNetworkAvailable = isInternetConnectionAvailable();
        if (isNetworkAvailable === false) {
            const errorLang = getErrorOrSuccessMessage();
            setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.networkOfflineInMaori : MoeErrorMessages.networkOffline);
            return;
        }
        if (!user?.isAuthenticated) {
            const errorLang = getErrorOrSuccessMessage();
            setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.unAuthenticatedInMaori : MoeErrorMessages.unAuthenticated);
            return;
        }

        const isCollectionAvailable = await doesCollectionExist(collectionId);
        if (isCollectionAvailable) {
            const isDuplicateName = await doesDuplicateNameExists(changedCollectionName);
            if (!isDuplicateName) {
                try {
                    const updateCommerceList = await updateAsync(
                        { callerContext: props.context.actionContext },
                        { Id: collectionId, Name: changedCollectionName }
                    );
                    // const collectionList = collectionArray.map(collection => {
                    //     if (collection?.Id === collectionId) {
                    //         collection.Name = changedCollectionName;
                    //     }
                    //     return collection;
                    // });
                    // setCollectionArray(collectionList);
                    const collectionList = await getByCustomerAsync(
                        { callerContext: props.context.actionContext, bypassCache: 'get' },
                        null
                    );
                    setCollectionArray([...collectionList]);
                    console.log('Updated commerce list', updateCommerceList);
                    setIsModalOpen(false);
                    const successLang = getErrorOrSuccessMessage();
                    openAlert(
                        successLang === MAORI_LANG
                            ? MoeSuccessMessages.updateCollectionNameInMaori
                            : MoeSuccessMessages.updateCollectionName,
                        false
                    );
                    // openAlert(MoeSuccessMessages.updateCollectionName, false);
                } catch (e) {
                    const errorLang = getErrorOrSuccessMessage();
                    setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.unknownErrorInMaori : MoeErrorMessages.unknownError);
                    console.log(e);
                }
            } else {
                const errorLang = getErrorOrSuccessMessage();
                setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.duplicateNameInMaori : MoeErrorMessages.duplicateName);
                const filteredItem = collectionArray.find(collection => collection?.Id === collectionId);
                console.log('Filtered item in update collection', filteredItem);
                setCollectionTitle(filteredItem?.Name);
                return {
                    errorCode: 400,
                    errorMessage: 'Same name already exists in collection'
                };
            }
        } else {
            const errorLang = getErrorOrSuccessMessage();
            setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.emptyCollectionInMaori : MoeErrorMessages.emptyCollection);
            telemetry.debug("[Update] Can't update from wishlist since no wishlist exists OR there is no product data");
        }

        return AsyncResult.resolve();
    };

    // @info: This method deletes the collection using collection id
    const deleteCollection = async (event: any, collectionId: number): Promise<void> => {
        const isNetworkAvailable = isInternetConnectionAvailable();
        if (isNetworkAvailable === false) {
            return;
        }

        setErrorMessage('');
        event.stopPropagation();
        const { context } = props;
        const { telemetry } = context;

        console.log('Delete collection');

        if (context.request.user.isAuthenticated) {
            const isCollectionAvailable = await doesCollectionExist(collectionId);
            if (isCollectionAvailable) {
                const collection = collectionArray.find(collectionItem => collectionItem.Id === collectionId);
                try {
                    const deleteCommerceList = await deleteAsync({ callerContext: props.context.actionContext }, { Id: collection.Id });
                    console.log('[RemoveCollection] collection deleted successfully', deleteCommerceList);
                } catch (e) {
                    const errorLang = getErrorOrSuccessMessage();
                    setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.unknownErrorInMaori : MoeErrorMessages.unknownError);
                    console.log(e);
                }
            } else if (telemetry) {
                const errorLang = getErrorOrSuccessMessage();
                setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.emptyCollectionInMaori : MoeErrorMessages.emptyCollection);
                telemetry.debug("[RemoveCollection] Can't remove collection since no collection exists ");
            }
        } else {
            const errorLang = getErrorOrSuccessMessage();
            setErrorMessage(errorLang === MAORI_LANG ? MoeErrorMessages.unAuthenticatedInMaori : MoeErrorMessages.unAuthenticated);
            return;
        }

        const collectionList = await getByCustomerAsync(props.context.actionContext, null);
        setCollectionArray(collectionList);

        return AsyncResult.resolve();
    };

    const _alertModal = (): INodeProps => {
        return {
            tag: Modal,
            placement: 'bottom-end',
            hideArrow: false,
            className: 'msc-modal__dialog-success',
            wrapClassName: '',
            isOpen: isAlertOpen,
            toggle: () => {
                setAlertOpen(false);
                if (MsDyn365.isBrowser && isRefreshPage) {
                    //location.reload();
                }
            }
        };
    };
    const closeAlert = () => {
        setAlertOpen(false);
        setAlertMessage('');
        if (isRefreshPage) {
            setIsRefreshPage(false);
            if (MsDyn365.isBrowser) {
                //location.reload();
            }
        }
    };
    const openAlert = (msg: string, isreload: boolean) => {
        setAlertOpen(true);
        setAlertMessage(msg);
        setIsRefreshPage(isreload);
    };

    return (
        <div className='moe-btn-iconlink-wrap'>
            <div
                className='moe-btn-iconlink moe-btn-iconlink--addtocollection'
                data-toggle='modal'
                data-target='#exampleModalCenter'
                onClick={(e: any) => openModal(e)}
                tabIndex={0}
                onKeyPress={(event: any) => (event.charCode === 13 ? openModal(event) : null)}
            >
                <AiOutlinePlus
                    className='moe-btn-iconlink__icon tooltip-test'
                    title={collectionSiteLang === 'maori' ? resources.addToCollectionTextInMaori : resources.addToCollectionText}
                />
                <p
                    className='moe-btn-iconlink__txt'
                    title={collectionSiteLang === 'maori' ? props.config.modalTitleMaori : props.config.modalTitle}
                >
                    {collectionSiteLang === 'maori' ? props.config.modalTitleMaori : props.config.modalTitle}
                </p>
            </div>
            <Node {..._modalContainer()}>
                {user?.isAuthenticated ? (
                    <div
                        className='msc-modal__add-collection'
                        id='exampleModalCenter'
                        tabIndex={-1}
                        role='dialog'
                        aria-labelledby='exampleModalCenterTitle'
                        aria-hidden='true'
                    >
                        <div className='modal fade' role='dialog' aria-hidden='true'>
                            <div className='modal-dialog' role='document'>
                                <div className='modal-content'>
                                    <div className='msc-collection-modal__header'>
                                        <div className='msc-collection-modal__header--left'>
                                            <h5 className='modal-title' tabIndex={0}>
                                                {collectionSiteLang === MAORI_LANG ? props.config.modalTitleMaori : props.config.modalTitle}{' '}
                                            </h5>
                                        </div>
                                        <div className='msc-collection-modal__header--right'>
                                            <div className='msc-addnewcollection-btn-wrap'>
                                                {' '}
                                                <span className='moe-btn-txt' tabIndex={0}>
                                                    {collectionSiteLang === MAORI_LANG
                                                        ? resources.newCollectionTextInMaori
                                                        : resources.newCollectionText}
                                                </span>
                                                <AiOutlinePlus
                                                    onClick={createCollection}
                                                    tabIndex={0}
                                                    className={`msc-addnewcollection-btn tooltip-test ${
                                                        isCollectionCreated ? 'msc-addnewcollection-grayout' : ''
                                                    }`}
                                                    title={
                                                        collectionSiteLang === MAORI_LANG
                                                            ? resources.createCollectionTextInMaori
                                                            : resources.createCollectionText
                                                    }
                                                    onKeyPress={(event: any) =>
                                                        event.charCode === 13 && !isCollectionCreated ? createCollection() : null
                                                    }
                                                />
                                            </div>
                                            <FaPlus
                                                onClick={closeModal}
                                                tabIndex={0}
                                                type='button'
                                                className='msc-collection-modal__close tooltip-test'
                                                title={collectionSiteLang === MAORI_LANG ? resources.closeTextInMaori : resources.closeText}
                                                style={{ transform: 'rotate(45deg)' }}
                                                onKeyPress={(event: any) => (event.charCode === 13 ? closeModal() : null)}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        style={{ marginBottom: errorMessage ? '1rem' : '0rem' }}
                                        className={`moe-addtocollection-err--text moe-form__validation ${
                                            errorMessage ? 'fadeInTop' : 'fadeOutTop'
                                        }`}
                                    >
                                        {errorMessage}
                                    </div>
                                    <div className='msc-collection-modal__body'>
                                        <div className='msc-alert msc-alert-warning'>
                                            {MoeModuleTranslations.heyText} {user.firstName || 'User'},{' '}
                                            {MoeModuleTranslations.addNewCollection}
                                        </div>
                                    </div>
                                    {collectionArray.length > 0 ? (
                                        <div ref={scrollRef} className='msc-collection-modal__collections '>
                                            {collectionArray.map((collection: any, index: number) =>
                                                collection.IsPrivate === true ? null : (
                                                    <CollectionItem
                                                        index={index}
                                                        isCheckboxEnabled={false}
                                                        collection={collection}
                                                        key={collection.Id}
                                                        isClickCollectionEnabled={false}
                                                        onClickCollection={(index: number, collectionId: number) =>
                                                            selectCollection(index, collectionId)
                                                        }
                                                        onCheckboxSelect={() => {
                                                            return;
                                                        }}
                                                        context={props.context}
                                                        id={props?.id}
                                                        typeName={'add'}
                                                        data={collection}
                                                        isEditEnabled={true}
                                                        isDeleteEnabled={false}
                                                        isTickMarkVisible={isCollectionEditable}
                                                        toggleEditableCollection={() => toggleEditableCollection(index)}
                                                        deleteCollection={(event, collectionId) => deleteCollection(event, collectionId)}
                                                        selectCollection={(index: number, collectionId: number) =>
                                                            selectCollection(index, collectionId)
                                                        }
                                                        updateCollectionName={(collectionId, changedCollectionName, setCollectionTitle) =>
                                                            updateCollectionName(collectionId, changedCollectionName, setCollectionTitle)
                                                        }
                                                        selectedCollection={selectedCollection}
                                                        className='msc-collection-modal__collection'
                                                        //@ts-ignore
                                                        setErrorMessage={setErrorMessage}
                                                        MoeErrorMessages={MoeErrorMessages}
                                                        preferredLanguageForError={errorOrNotificationMsgLang}
                                                        siteLang={collectionSiteLang}
                                                    ></CollectionItem>
                                                )
                                            )}
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                    <div className='msc-collection-modal__footer'>
                                        <button
                                            className={`moe-btn moe-btn--primary-blue moe-btn--add-to-collection ${
                                                selectedCollection?.collectionId === -1 ? 'msc-collection-modal__button' : ''
                                            } tooltip-test`}
                                            style={{ fontWeight: 'bold' }}
                                            type='button'
                                            title={
                                                selectedCollection?.collectionId === -1
                                                    ? MoeModuleTranslations.addToCollectionText
                                                    : MoeModuleTranslations.addToCollectionText
                                            }
                                            data-dismiss='modal'
                                            disabled={selectedCollection?.collectionId === -1 || hasBeenCalled ? true : false}
                                            onClick={() => addToCollection(selectedCollection?.collectionId)}
                                        >
                                            {MoeModuleTranslations.addToCollectionText}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='msc-modal__add-collection'>
                        <div className='modal fade' role='dialog' aria-hidden='true'>
                            <div className='modal-dialog modal-dialog-centered' role='document'>
                                <div className='modal-content'>
                                    <div className='msc-collection-modal__header'>
                                        <h5 className='modal-title'>
                                            {collectionSiteLang === MAORI_LANG ? props.config.modalTitleMaori : props.config.modalTitle}
                                        </h5>
                                        <FaPlus
                                            onClick={closeModal}
                                            type='button'
                                            className='msc-collection-modal__close'
                                            style={{ transform: 'rotate(45deg)' }}
                                            tabIndex={0}
                                            onKeyPress={(event: any) => {
                                                console.log('test99615 - calling toggleEdit from onKeyPress', event, event.charCode);
                                                event.charCode === 13 ? closeModal : null;
                                            }}
                                        />
                                    </div>
                                    <div className='msc-collection-modal__body'>
                                        <div className='msc-alert msc-alert-warning'>{MoeModuleTranslations.notLoggedIn}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Node>
            <Node {..._alertModal()}>
                <div className='modal-content'>
                    <div className='msc-modal__header'>
                        <h5 className='msc-modal__title'>
                            <div>
                                <h5>{errorOrNotificationMsgLang === MAORI_LANG ? 'Kua tutuki' : 'Success'}</h5>
                            </div>
                        </h5>
                        <button
                            type='button'
                            onClick={() => {
                                closeAlert();
                            }}
                            className='msc-modal__close-button'
                            aria-label='Close'
                        ></button>
                    </div>
                    <div className='msc-alert msc-alert-success'>{alertMessage}</div>
                </div>
            </Node>
        </div>
    );
};
